import { combineReducers } from 'redux';

import * as SagasType from '../constants/constant_saga_types';
import * as ActionType from '../constants/constant_action_types';

// -------------------------------------
// Get results from execution of report
// -------------------------------------
function byResultsReducer(state = {}, action) {
  switch (action.type) {
    case SagasType.SHOW_REPORT_DONE: {
      const { key, reportId, filters, results } = action;
      return {
        ...state,
        [key]: {
          reportId,
          filters,
          results: (results || {}).results,
          expanded: (results || {}).expanded
        }
      };
    }

    case SagasType.SHOW_REPORT_INPROGRESS: {
      const { key, reportId, filters } = action;
      return {
        ...state,
        [key]: {
          ...state[key],
          reportId,
          filters,
          isFetching: true
        }
      };
    }
  
    case SagasType.SHOW_REPORT_ERROR: {
      const { key, reportId, filters, error } = action;
      return {
        ...state,
        [key]: { reportId, filters, error }
      };
    }

    default:
      return state;
  }
}

// -------------------------------------
// List all reports
// -------------------------------------
const byAllReducer = function(state = {}, action) {
  switch (action.type) {
    case SagasType.SHOW_ALL_REPORTS_INPROGRESS: {
      return { isFetching: true };
    }
    case SagasType.SHOW_ALL_REPORTS_ERROR: {
      const { error } = action;
      return { error };
    }
    case SagasType.SHOW_ALL_REPORTS_DONE: {
      const { results } = action;
      return { results };
    }
    default:
      return state;
  }
};

// -------------------------------------
// Get report by id
// -------------------------------------
const byIdReducer = function(state = {}, action) {
  switch (action.type) {
    case SagasType.SHOW_REPORT_BY_ID_DONE: {
      const { id, doc } = action;
      return {
        ...state,
        [id]: { id, doc }
      };
    }
    case SagasType.SHOW_REPORT_BY_ID_INPROGRESS: {
      const { id } = action;
      return {
        ...state,
        [id]: {
          id,
          isFetching: true
        }
      };
    }
    case SagasType.SHOW_REPORT_BY_ID_ERROR: {
      const { id, error } = action;
      return {
        ...state,
        [id]: { id, error }
      };
    }
    default:
      return state;
  }
};

// -------------------------------------
// Report exports
// -------------------------------------
const reportExportsReducer = function(state = {}, action) {
  switch (action.type) {
    case ActionType.SET_REPORT_DATA_EXPORTS: {
      const { data, reportId } = action;
      return {
        ...state,
        [reportId]: { ...data }
      };
    }
    default:
      return state;
  }
};

export const reportsReducer = combineReducers({
  byId: byIdReducer,
  byAll: byAllReducer,
  byResult: byResultsReducer,
  reportExports: reportExportsReducer
});
